export default "__VITE_PUBLIC_ASSET__65d26919__"